import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductDescriptionSectionComponent } from '../../../app/content/modules/page/components/product/components/product-description-section/product-description-section.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../../_mocks/wine-product.mock';

const meta: Meta<ProductDescriptionSectionComponent> = {
  title: 'Organisms/Product/Product Description Section',
  component: ProductDescriptionSectionComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<ProductDescriptionSectionComponent>;

export const Default: Story = {
  args: { product: createDamilanoBarberaProduct() },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/damilano barbera/i)).toBeInTheDocument();
  },
};

export const WithYouTubeVideo: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      youTubeId: 'dQw4w9WgXcQ',
    }),
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/damilano barbera/i)).toBeInTheDocument();
  },
};

export const LongDescription: Story = {
  args: {
    product: createDamilanoBarberaProduct({
      productDescription:
        'En fremragende Bordeaux vin fra den berømte Château Margaux vingård. '.repeat(20) +
        '\n\nDenne vin udtrykker terroir med elegance og dybde. ' +
        'Vinens bouquet er kompleks med noter af mørke bær, cedertræ og krydderier. '.repeat(10),
    }),
  },  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/damilano barbera/i)).toBeInTheDocument();
  },};
